// theme.js
import { createTheme } from "@mui/material/styles";

export const themeDevelopment = createTheme({
  palette: {
    primary: {
      main: "#004aad" // Azul corporativo
    },
    secondary: {
      main: "#f50057" // Rosa
    },
    background: {
      default: "#f8f9fa" // Fondo gris claro
    }
  },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none"
        },
        colorPrimary: {
          backgroundColor: "#004aad"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#fff",
          height: 3,
          borderRadius: 2
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          minWidth: 100
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "6px"
        }
      }
    }
  }
});

export const themeProduction = createTheme({
  palette: {
    primary: {
      main: "#7c3aed" // Púrpura de producción
    },
    secondary: {
      main: "#f50057" // Rosa
    },
    background: {
      default: "#f8f9fa" // Fondo gris claro
    }
  },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none"
        },
        colorPrimary: {
          backgroundColor: "#7c3aed"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#fff",
          height: 3,
          borderRadius: 2
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          minWidth: 100
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "6px"
        }
      }
    }
  }
});
